import GoogleMapsRoutesApiService from '@shared/services/google-maps-routes-api';
import { useMutation } from 'react-query';

export const useCalculateDirectionMutation = (options: any): any => {
  return useMutation(
    GoogleMapsRoutesApiService.getCalculatedDirection as any,
    options
  );
};
